import { Injectable } from '@angular/core';
import { CommandHelper, QuickCommandService } from '@app/shared/quick-commands';
import { StoppableListener } from '@app/utils/stoppable-listener';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RevealDetailsService {
  private visibleSubject = new BehaviorSubject<boolean>(false);
  private visible: boolean = false;

  private listener = new StoppableListener<KeyboardEvent>({
    start: (cb) => {
      document.addEventListener('keydown', cb);
      document.addEventListener('keyup', cb);
    },
    stop: (cb) => {
      document.removeEventListener('keydown', cb);
      document.removeEventListener('keyup', cb);
    },
  });

  private callback = (event: KeyboardEvent) => {
    this.toggleVisible(event.altKey && event.ctrlKey);
  };

  get visible$(): Observable<boolean> {
    return this.visibleSubject.asObservable();
  }

  constructor(private quickCommandService: QuickCommandService) {}

  public initialize(): void {
    this.quickCommandService.add({
      action: () => {
        if (this.listener.enabled) {
          this.listener.stop();
        } else {
          this.listener.start();
        }

        this.toggleVisible();

        return CommandHelper.close();
      },
      icon: 'far fa-eye',
      label: () => {
        if (this.visible) {
          return 'quickCommands.commands.revealDetails.hide';
        } else {
          return 'quickCommands.commands.revealDetails.show';
        }
      },
      name: 'reveal-details',
    });

    this.listener.add(this.callback);
  }

  /**
   * Toggle visibility.
   *
   * @param force Set to the given value.
   */
  public toggleVisible(force?: boolean): void {
    if (force != null) {
      this.visible = force;
    } else {
      this.visible = !this.visible;
    }

    this.visibleSubject.next(this.visible);
  }
}
